import jsPDF from "jspdf";
import "jspdf-autotable";
import { number } from "joi";

const generatePDFDebit = (
  facilityName,
  inmateName,
  inmateId,
  tableHeaders,
  tableRows,
  totalDebitAmount,
  totalCreditAmount,
  isLandscape,
  title
) => {
  const doc = new jsPDF({
    orientation: isLandscape ? "landscape" : "portrait",
  });

  const pageWidth = doc.internal.pageSize.getWidth(); // Get page width
  const marginLeft = 14;
  let currentY = 10; // Initial Y position

  // **Add the current date (Top Right)**
  const currentDate = new Date().toLocaleDateString("en-US", {
    month: "2-digit",
    day: "2-digit",
    year: "numeric",
  });
  
  doc.setFontSize(10);
  doc.text(currentDate, pageWidth - marginLeft, currentY, { align: "right" });
  

  // **Add the title (Bold & Left Aligned)**
  currentY += 8;
  doc.setFontSize(14);
  doc.setFont("helvetica", "bold");
  doc.text("INMATE DEBIT HISTORY", marginLeft, currentY);

  // **Add facility, inmate name, and ID details**
  doc.setFontSize(11);
  currentY += 8;
  doc.setFont("helvetica", "normal");
  doc.text(`Facility Code  :  `, marginLeft, currentY);
  doc.setFont("helvetica", "bold");
  doc.text(facilityName, marginLeft + 30, currentY);

  doc.setFont("helvetica", "normal");
  doc.text(`Inmate Name  :  `, marginLeft, currentY + 6);
  doc.setFont("helvetica", "bold");
  doc.text(inmateName, marginLeft + 30, currentY + 6);

  doc.setFont("helvetica", "normal");
  doc.text(`Inmate ID  :  `, pageWidth - 50, currentY + 6);
  doc.setFont("helvetica", "bold");
  doc.text(String(inmateId), pageWidth - 30, currentY + 6);

  // **Draw a separator line**
  currentY += 12;
  doc.setLineWidth(0.5);
  doc.line(marginLeft, currentY, pageWidth - marginLeft, currentY);

  // **Add the table**
  currentY += 5;
  doc.autoTable({
    head: [tableHeaders], // Table headers
    body: tableRows, // Table rows as an array of arrays
    startY: currentY,
    styles: {
      fontSize: 10,
      halign: "center",
      textColor: "black",
      lineColor: "black",
      lineWidth: 0.5,
    },
    headStyles: {
      fillColor: [255, 255, 255], // White background
      textColor: "black",
      fontStyle: "bold",
      lineColor: "black",
      lineWidth: 0.5, // Important for visible header borders
    },
    bodyStyles: {
      textColor: "black",
      lineColor: "black",
      lineWidth: 0.5,
    },
    theme: "grid", // Ensures all borders show
  });

  // **Calculate the Total Amounts**
  let finalY = doc.lastAutoTable.finalY + 10;

  doc.setFont("helvetica", "bold");

  // Ensure totalDebitAmount is a valid number
  const debitAmount = Number(totalDebitAmount) || 0;
  const creditAmount = Number(totalCreditAmount) || 0;

  doc.text(`Total Debit Amount`, marginLeft + 110, finalY);
  doc.text(`:  $${debitAmount.toFixed(2)}`, marginLeft + 170, finalY);

  finalY += 6;
  doc.text(`Total Credit Amount`, marginLeft + 110, finalY);
  doc.text(`:  $${creditAmount.toFixed(2)}`, marginLeft + 170, finalY);

  // **Save the PDF**
  doc.save(`${title}.pdf`);
};

export default generatePDFDebit;
